import { storage, storageKey } from '@lib/storage'
import { withClientSide } from './client-side'

// authToken

export function getAuthToken(): string | null | undefined {
  return withClientSide(() =>
    storage.local.getByKey<string>(storageKey.authToken)
  )
}

export function setAuthToken(token: string) {
  return withClientSide(() =>
    storage.local.setByKey<string>(storageKey.authToken, token)
  )
}

export function clearAuthToken() {
  return withClientSide(() =>
    storage.local.removeByKey<string>(storageKey.authToken)
  )
}

// prospectToken

export function getProspectToken(): string | null | undefined {
  return withClientSide(() =>
    storage.local.getByKey<string>(storageKey.prospectToken)
  )
}

export function setProspectToken(token: string) {
  return withClientSide(() =>
    storage.local.setByKey<string>(storageKey.prospectToken, token)
  )
}

export function clearProspectToken() {
  return withClientSide(() =>
    storage.local.removeByKey<string>(storageKey.prospectToken)
  )
}

// user

export function getSessionUser(): string | undefined {
  return withClientSide(() => storage.local.getByKey(storageKey.user))
}

export function setSessionUser(value: string) {
  return withClientSide(() => storage.local.setByKey(storageKey.user, value))
}

export function clearSessionUser() {
  return withClientSide(() => storage.local.removeByKey(storageKey.user))
}
